import { singleWoman, singleMan } from './ComboValues'
// required = 1 notRequired = 0

// All required fields in forms
export const family_program_info = {
    program_date: 1,
    program_end_date: 0,
    program_end_data1_date: 0,
    program_status: 1,
    intake_status: 0,
    intake_yahav_member: 1,
    intake_family_name: 1,
    intake_family_woman_name: singleWoman,
    intake_family_man_name: singleMan,
    mertial_status: 1,
    mertial_status_comment: 0,
    kids_number: 1,
    young_kid_age: 0,
    eldest_kid_age: 0,
    family_in_revaha: 1,
    family_revaha_intense: 0,
    family_address: 1,
    family_zipcode: 0,
    family_town: 0,
    family_phone: 0,
    man_cellphone: singleMan,
    woman_cellphone: singleWoman,
    other_programs: 1,
    other_programs_list: 0,
    referral_code: 0,
    intake_code: 0,
    program_code: 0,
    family_old_code: 0
}

export const family_housing =  {
    family_house: 1,
    family_persons_athome: 1,
    family_room_num: 1,
    family_house_status: 1,
    family_housing_comment: 0
}

export const family_legal = {
    need_legal: 1,
    legal_explain: 0
}

export const parent_info = {
    parent_family_name: 1,
    parent_first_name: 1,
    parent_idnum: 1,
    parent_gender: 1,
    parent_phone1: 1,
    parent_email: 0,
    parent_birth_date: 1,
    parent_birth_country: 1,
    parent_immigration_year: 0,
    parent_social_section: 1,
    parent_health: 0, // really??
    parent_bituachleumi: 0, // really??
    parent_bituachleumi_temp: 0,
    parent_kupat_holim: 0, // really??
    parent_merital_status: 1,
    parent_married_number: 0,
    parent_family: 0,
    parent_partner: 0,
    parent_kids: 0
}

export const parent_hstatus = {
    id: 0,
    parent_health: 1,
    parent_bituachleumi: 1,
    parent_bituachleumi_temp: 0,
    parent_kupat_holim: 1,
    comment: 0
}

export const parent_notemployed =  {
    notemp_workbefore: 1 ,
    notemp_howlong: 1,
    notemp_why: 1,
    notemp_look4work: 1,
    notenough: 0,
    noreview: 0,
    nopass: 0,
    nostay: 0,
    other: 0,
    places_last3y: 1
}

export const parent_employment = {
    employ_status: 1,
    employ_prev_places: 1,
    employ_main: 1,
    employ_role: 1,
    employ_duration: 1,
    employ_quality: 1,
    employ_current_place: 1,
    employ_cap_percent: 1,
    employ_cap_hours: 1,
    employ_social: 1,
    employ_bruto: 1,
    employ_neto: 1,
    employ_prev_exp: 0,
    employ_comments: 0,
    employ_interest_inchange: 1,
    employ_i1: 1,
    employ_i2: 1,
    employ_i3: 1,
    employ_i4: 1,
    employ_i5: 1,
    employ_i6: 0,
    employ_new_buisness: 1,
    employ_new_buis_other: 0,
    employ_volunteer: 1,
    employ_last3y: 1
}

export const parent_education = {
    year_of_study: 1,
    bagroot: 1,
    professional: 1,
    academic_education: 1,
    secular_education: 1,
    profession: 1,
    comment: 0
}